import { gql, useMutation } from "@apollo/client";
import type { IdeaBook } from "./types";

const CREATE_IDEA_BOOK = gql`
  mutation CreateIdeaBook($homeownerId: ID!, $name: String!) {
    createIdeaBook(homeownerId: $homeownerId, name: $name) {
      _id
      homeownerId
      name
      itemCount
      createdAt
      updatedAt
      coverImage {
        _id
        url
        path
        title
        description
        credit
      }
    }
  }
`;

type CreateIdeaBookData = {
  createIdeaBook: IdeaBook;
};

type CreateIdeaBookVars = {
  homeownerId: string;
  name: string;
};

export const useCreateIdeaBook = () => {
  const [createIdeaBookMutation, { loading, error, data }] = useMutation<
    CreateIdeaBookData,
    CreateIdeaBookVars
  >(CREATE_IDEA_BOOK);

  const createIdeaBook = async (args: CreateIdeaBookVars) => {
    const result = await createIdeaBookMutation({ variables: args });
    return result.data?.createIdeaBook ?? null;
  };

  return { createIdeaBook, loading, error, data };
};
